module.exports = __webpack_public_path__ + "2cd173e7.png";